// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COUNSELLING_ALL_TOPICS = "V\u0161etky poradne";
export const COUNSELLING_ARCHIVED_TOPICS = "Arch\u00edv poradn\u00ed";
export const COUNSELLING_NEWEST_RESPONSES = "Najnov\u0161ie zodpovedan\u00e9 ot\u00e1zky";
export const COUNSELLING_OTHER_TOPICS = "Ostatn\u00e9 poradne";
export const COUNSELLING_TOPICS_I_AM_FOLLOWING = "Poradne, ktor\u00e9 odober\u00e1m";
export const TOPIC_MODERATOR = "Moder\u00e1tor";
